export const DEFAULT = {
  HEADING: 'Get An Official\nInstant Cash Offer',
  SUBHEADING: 'And Trade-Up To A New BMW Today!',
  TAB_LIST: ['vin', 'plate', 'ymm'],
  LEGAL_CONTENT:
    'Your Instant Cash Offer may be lower than the Kelley Blue Book Trade-In Range. For limitations, see the Kelley Blue Book <a data-testid="bi-btn-term-and-contitions" href="https://www.kbb.com/company/terms-of-service/#termsAndConditions" target="_blank">Program Terms and Conditions</a>.',
};

/**
 * Theme configuration dictionary for formatting display names
 */
export const THEME_CONFIG = {
  bmw: {
    displayName: 'BMW',
  },
} as const;

/**
 * Formats a theme name for display purposes using the theme configuration
 * @param theme - The theme name to format
 * @returns Formatted theme name based on theme configuration
 */
export const formatThemeName = (theme: string): string => {
  if (!theme || theme === 'undefined') {
    return 'Vehicle';
  }

  const themeKey = theme.toLowerCase();
  const themeConfig = THEME_CONFIG[themeKey as keyof typeof THEME_CONFIG];

  if (themeConfig) {
    return themeConfig.displayName;
  }

  // Default formatting for themes not in the dictionary
  return theme.charAt(0).toUpperCase() + theme.slice(1);
};

// returns the theme text for subheader
export const GetLandingOemSubheader = (theme = '') => {
  const formattedThemeName = formatThemeName(theme);
  return `And Trade-Up To A New ${formattedThemeName} Today!`;
};
